import { useEffect, useState } from "react";
import { ROOM_CODE_LENGTH } from "@grundbesitz/shared";

/** Tiny path router: "/" is the start page, "/K7Q2ZP" is a room. */
export function parsePath(pathname: string): { page: "home" } | { page: "room"; code: string } {
  const seg = pathname.replace(/^\/+|\/+$/g, "").toUpperCase();
  if (seg.length === ROOM_CODE_LENGTH && /^[A-Z0-9]+$/.test(seg)) return { page: "room", code: seg };
  return { page: "home" };
}

export function navigate(path: string, replace = false) {
  if (replace) window.history.replaceState(null, "", path);
  else window.history.pushState(null, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function usePath() {
  const [path, setPath] = useState(() => window.location.pathname);
  useEffect(() => {
    const on = () => setPath(window.location.pathname);
    window.addEventListener("popstate", on);
    return () => window.removeEventListener("popstate", on);
  }, []);
  return parsePath(path);
}

export function inviteLink(code: string): string {
  return `${window.location.origin}/${code}`;
}
